(function ($) {
  'use strict';
  $(function () {
    $(document).on('click', '.fort__menu', function () {
      $(this).toggleClass('fort__menu_opened')
      $('.major__left').toggleClass('major__left_opened')
    });
    jQuery(document).on('click', function (e) {
      const el = jQuery(e.target).closest('.major__left,.fort__menu');
      if (el.length) return;
      $('.fort__menu').removeClass('fort__menu_opened')
      $('.major__left').removeClass('major__left_opened')
    });
  });
})(jQuery);
